import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'cre-charte',
    templateUrl: './charte.component.html',
    styleUrls: ['./charte.component.scss']
})
export class CharteComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
